import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";
import { FirewallStatus, FirewallStatusConverter } from "./firewall-status";

@JsonConverter
export class MonitoringFirewallArrayConverter implements JsonCustomConvert<Array<MonitoringFirewall>>{
	serialize() { }
	deserialize(data: any): Array<MonitoringFirewall> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, MonitoringFirewall);
	}
}

@JsonObject("MonitoringFirewall")
export class MonitoringFirewall {
	@JsonProperty("ttl", Number, true)
	ttl: number = 0;
	@JsonProperty("status", FirewallStatusConverter, true)
	status: FirewallStatus = FirewallStatus.UNDEFINED;
	@JsonProperty("protocol", String, true)
	protocol: string = "";
	@JsonProperty("dest_address", String, true)
	dest_address: string = "";
	@JsonProperty("dest_port", Number, true)
	dest_port: number = 0;
}

@JsonObject("MonitoringFirewallList")
export class MonitoringFirewallList extends BaseResponse {
	@JsonProperty("count", Number, true)
	count: number = 0;
	@JsonProperty("data", MonitoringFirewallArrayConverter, true)
	data: Array<MonitoringFirewall> = new Array<MonitoringFirewall>();
}